// Shared block definitions for CMS pages.
// Used by both the admin editor and the public block renderer.

export const BLOCK_TYPES = [
  {
    type: "hero",
    label: "Hero (Bild + Titel)",
    icon: "fa-image",
    description: "Großes Bild mit Überschrift, Untertitel und optionalem CTA-Button.",
    defaults: {
      image: "",
      overline: "",
      title: "Neue Sektion",
      subtitle: "Beschreibungstext der Sektion.",
      cta_text: "",
      cta_link: "",
    },
  },
  {
    type: "heading",
    label: "Überschrift",
    icon: "fa-heading",
    description: "Einfache Überschrift mit optionaler Vorzeile.",
    defaults: { overline: "", title: "Überschrift", subtitle: "" },
  },
  {
    type: "text",
    label: "Textblock",
    icon: "fa-align-left",
    description: "Mehrzeiliger Fließtext (Markdown-light unterstützt: **fett**, *kursiv*).",
    defaults: { body: "Schreibe hier deinen Text …" },
  },
  {
    type: "image",
    label: "Einzelbild",
    icon: "fa-image",
    description: "Einzelnes Bild mit Bildunterschrift.",
    defaults: { url: "", alt: "", caption: "" },
  },
  {
    type: "gallery",
    label: "Bildergalerie",
    icon: "fa-images",
    description: "Mehrere Bilder im Raster (3 Spalten).",
    defaults: { images: [] },
  },
  {
    type: "cta",
    label: "Call-to-Action",
    icon: "fa-bullhorn",
    description: "Auffällige Action-Box mit Hintergrundfarbe und Button.",
    defaults: {
      title: "Bereit loszulegen?",
      subtitle: "Jetzt zur Aktion …",
      button_text: "Los geht's",
      button_link: "/contact",
      bg_color: "#5a6e3f",
    },
  },
  {
    type: "plant_carousel",
    label: "Pflanzen-Karussell",
    icon: "fa-leaf",
    description: "Zeigt Pflanzen aus der Datenbank (optional gefiltert).",
    defaults: { title: "Empfohlene Pflanzen", category: "all", season: "all", limit: 6 },
  },
  {
    type: "video",
    label: "Video-Embed",
    icon: "fa-video",
    description: "Bettet YouTube- oder Vimeo-Videos ein.",
    defaults: { url: "", caption: "" },
  },
  {
    type: "tour_list",
    label: "Touren-Liste",
    icon: "fa-route",
    description: "Zeigt aktuelle geführte Touren.",
    defaults: { title: "Nächste Touren", limit: 3 },
  },
  {
    type: "newsletter",
    label: "Newsletter-Box",
    icon: "fa-envelope",
    description: "Newsletter-Anmeldeformular.",
    defaults: { title: "Bleib auf dem Laufenden", subtitle: "Wöchentlich Pflanze der Woche per E-Mail." },
  },
  {
    type: "spacer",
    label: "Abstand",
    icon: "fa-arrows-up-down",
    description: "Vertikaler Leerraum zwischen Blöcken.",
    defaults: { size: "md" }, // sm | md | lg
  },
];

export function getBlockMeta(type) {
  return BLOCK_TYPES.find((b) => b.type === type) || BLOCK_TYPES[0];
}
